import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';
import { GetMeResponseDTO } from './dto/brain-auth.getMe.response.dto';
import { BrainAuthSignaturesService } from './signatures/brain-auth-signatures';
import { GetStatusResponseDTO } from './dto/brain-auth.getStatus.response.dto';
import { GetStatusParamsDTO } from './dto/brain-auth.getStatus.params.dto';

export class BrainAuthService {
  private readonly client: ApiInstance;
  public signatures: BrainAuthSignaturesService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/auth`, client.getTimeout());
    this.signatures = new BrainAuthSignaturesService(this.client);
  }

  async getMe(request?: { settings?: RetrySettings }): Promise<GetMeResponseDTO> {
    return (
      await this.client.get<GetMeResponseDTO>(
        `me`,
        {},
        {
          bearerToken: await getAuthToken(),
          settings: request?.settings,
        },
      )
    ).data;
  }

  async getStatus(request: { params: GetStatusParamsDTO; settings?: RetrySettings }): Promise<GetStatusResponseDTO> {
    return (
      await this.client.get<GetStatusResponseDTO>(`status`, request.params, {
        bearerToken: await getAuthToken(),
        settings: request?.settings,
      })
    ).data;
  }
}
